var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80669 5.60335C5.03877 5.59888 5.24184 5.50739 5.4159 5.32887L9.38577 1.31884C9.52859 1.17155 9.6 0.990794 9.6 0.776573C9.6 0.557882 9.52524 0.373783 9.37572 0.224275C9.22622 0.0747584 9.04435 0 8.83012 0C8.62036 0 8.43291 0.0803337 8.26778 0.241002L4.55231 4.01674H5.06109L1.3389 0.241002C1.17378 0.0803337 0.986332 0 0.776571 0C0.55788 0 0.373781 0.0747584 0.224273 0.224275C0.0747575 0.373783 0 0.557882 0 0.776573C0 0.986334 0.0736424 1.16709 0.220927 1.31884L4.19079 5.32887C4.37378 5.51186 4.57908 5.60335 4.80669 5.60335Z",
    fill: "#14213D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.7bdf6cb71764811ccf28540dbdddc53b.svg";
export { ForwardRef as ReactComponent };